export default __webpack_public_path__ + "static/media/img-welcome-bg@2x.3b6b9028.jpg";